import React from "react";
import '../css/Footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <img className="" src="logo/grigom_black.svg" alt="grigom_black_logo" width="130px" />
            <ul className="socials">
                <li>PHONE : 010.9537.9175</li>
                <li>EMAIL : director@grigompictures.com</li>
                <li>Copyright 2020. GRIGOM PICTURES. All rights reserved.</li>
            </ul>
        </div>
    );
};
export default Footer